import { Model } from '@favid-inc/api';
import { MessageState } from 'core/redux/types';
import _ from 'lodash';
import { registerMessage } from 'utils/message';
import { Action } from './types';

interface Params {
  onPut?: string;
  onFetch?: string;
  beforeProcessing?: string;
  onError?: string;
  initialState: {
    list: Model[];
    isLoading: boolean;
  };
}

export const instanceOfModel = (object: {}): object is Model => {
  return 'id' in object;
};

export const instanceOfMessage = (object: {}): object is MessageState => {
  return 'description' in object;
};

export function stateReducerFactory(params: Params) {
  const { onError = '', beforeProcessing = '', onFetch = '', onPut = '', initialState } = params;
  return (state = initialState, { type, payload }: Action): typeof initialState => {
    switch (type) {
      case onPut:
        if (payload && instanceOfModel(payload)) {
          const index = _.findIndex(state.list, { id: payload.id });
          state.list.splice(index, 1, payload);
          return { ...state, isLoading: false };
        }
        return state;
      case onFetch:
        return { ...state, ...payload, isLoading: false };
      case beforeProcessing:
        return { ...state, isLoading: true };
      case onError:
        if (payload && instanceOfMessage(payload)) {
          registerMessage(payload);
        }
        return { ...initialState };
      default:
        return state;
    }
  };
}
